import {fabric} from 'fabric'
import $ from "jquery"
import jcanvas from "jcanvas"
jcanvas($,window)
export default { 
    data() {
      return { 
        canvasM: '',
        contextM: '',
        imgX: 0,
        imgY: 0,
        imgScale: 1,
        MINIMUM_SCALE: 1,
        pos: {},
        posl: {},
        dragging: '',
        roadInfo: '',
        scale: 1,
      };
    },
 
    methods: { 
        initCanvas: function(canvas,midCanvas,setArr,type){
            var that = this
            this.roadInfo = setArr
            this.canvasM = document.getElementById('midCanvas'); //画布对象
            this.contextM = this.canvasM.getContext('2d');//画布显示二维图片
            canvas.selections = false
            // this.setGrid(canvas,"#ffffff")
            if(type==1){
              this.setUnRoad(canvas, setArr);
              this.drawImageF()
            }else{
              this.setRoad(canvas,setArr)
              this.drawImage()
            }
            //鼠标按下事件
            canvas.on("mouse:down", function(e) {
              console.log(e)
                if(e.target != null){
                    if('id' in e.target){
                        that.fabricClickId = e.target.id
                        that.fabricClickName = e.target.carName
                    }
                }else{
                    // if(midCanvas != ''){
                    //     that.$refs.setCarInfo.style.display = 'none'
                    // }
                    
                }
                this.panning = true;
                canvas.selection = false;

                this.dragging = true;
                // console.log(e)
                this.pos = that.windowToCanvas(e.pointer.x, e.pointer.y);  //坐标转换，将窗口坐标转换成canvas的坐标
            });
            //鼠标抬起事件
            canvas.on("mouse:up", function() {
                this.panning = false;
                canvas.selection = false;

                this.dragging = false;
            });
            // 移动画布事件
            canvas.on("mouse:move", function(e) {

                if(this.dragging){
                  console.log(e)
                  this.posl = that.windowToCanvas(e.pointer.x, e.pointer.y);
                  // console.log(this.posl)
                  // console.log(this.pos)
                  var x = this.posl.x - this.pos.x, y = this.posl.y - this.pos.y;
                  // let x = e.e.movementX
                  // let y = e.e.movementY
                  var delta = new fabric.Point(x,y);
                  canvas.relativePan(delta);
                  that.imgX = that.imgX + x
                  that.imgY = that.imgY + y
                  console.log(that.imgX)
                  console.log(that.imgY)
                  this.pos = JSON.parse(JSON.stringify(this.posl));
                  if(type!=1){
                    that.drawImage();  //重新绘制图片
                  }else{
                    that.drawImageF()
                  }
                  
                }
            });
            var leftTo = canvas._offset.left
            var topTo = canvas._offset.top
            //鼠标滚动画布放大缩小
            canvas.on("mouse:wheel", function(e) {
              console.log(canvas.getZoom())
                var zoom = (event.deltaY > 0 ? -0.1 : 0.1) + canvas.getZoom()*1;
                zoom = Math.max(1, zoom); //最小为原来的1/10
                that.$store.commit('setZoom', zoom)
                var zoomPoint = new fabric.Point(event.pageX-leftTo, event.pageY-topTo);
                canvas.zoomToPoint(zoomPoint, zoom);
                
                event.preventDefault()
                event.stopPropagation()
                
                console.log(e.e)
                console.log(event)
                console.log(that.imgScale)
                var pos = that.windowToCanvas (e.pointer.x, e.pointer.y);
                // event.wheelDelta = event.wheelDelta ? event.wheelDelta : (event.deltalY * (-40));  //获取当前鼠标的滚动情况
                var newPos = {x:((pos.x-that.imgX)/that.imgScale).toFixed(2) , y:((pos.y-that.imgY)/that.imgScale).toFixed(2)};
                let scale = that.imgScale
                if (event.wheelDelta > 0) {// 放大
                  scale = scale + 0.1;
                  that.imgX = (1-scale)*newPos.x+(pos.x-newPos.x);
                  that.imgY = (1-scale)*newPos.y+(pos.y-newPos.y);
                } else {//  缩小
                  scale = scale - 0.1;
                    if(scale<1) {//最小缩放1
                      scale = 1;
                    }
                    that.imgX = (1-scale)*newPos.x+(pos.x-newPos.x);
                    that.imgY = (1-scale)*newPos.y+(pos.y-newPos.y);
                    
                }
                console.log(that.imgX,that.imgY);
                that.imgScale = scale
                console.log(that.imgScale)
                if(type!=1){
                  that.drawImage();  //重新绘制图片
                }else{
                  that.drawImageF()
                }
            });
        },

        initCanvas_1: function(canvas,midCanvas,setArr,type){
          var that = this
          this.roadInfo = setArr
          // this.canvasM = document.getElementById('midCanvas'); //画布对象
          // this.contextM = this.canvasM.getContext('2d');//画布显示二维图片
          let eventCanvas = document.querySelector("#midCanvas")
          let ectx = eventCanvas.getContext("2d")
          if(type==1){
            this.setUnRoad(canvas, setArr);
            this.drawImageF()
          }else{
            this.setRoad(canvas,setArr)
            this.drawImage()
          }

          eventCanvas.onmousedown = function (event) {
            console.log(event)
            console.log(eventCanvas.offsetLeft)
            console.log(eventCanvas.offsetTop)
            // if (isfollowed) {
            //     follow();
            // }
        
            // Get mouse offset.
            var mousepos = {
                x: event.offsetX - eventCanvas.offsetLeft,
                y: event.offsetY - eventCanvas.offsetTop
            };
        
            eventCanvas.style.zIndex = "99999";
            eventCanvas.style.cursor = "move";
            let origin = {}
        
            window.onmousemove = function (evt) { // 移动
              console.log(evt)
              console.log(eventCanvas)
              that.dragging = true;
        
                var mousepos1 = {
                    x: evt.offsetX - eventCanvas.offsetLeft,
                    y: evt.offsetY - eventCanvas.offsetTop
                };
                // 屏幕移动距离到canvas移动距离转换
                var dx1 = (mousepos1.x - mousepos.x) / that.scale;
                var dy1 = (mousepos1.y - mousepos.y) / that.scale;
                mousepos = mousepos1;
                // for (var i = 0; i < canvasMove; i++) {
                //     ctxList[i].translate(dx1, dy1);
                // }
                console.log(dx1,dy1)
                ectx.translate(dx1, dy1);
                origin.x -= dx1;
                origin.y -= dy1;
            };
        
            window.onmouseup = function () {
              that.dragging = false;
        
                window.onmousemove = null;
                window.onmouseup = null;
                eventCanvas.style.cursor = "default";
                eventCanvas.style.zIndex = "99";
            };
          };
          
          //缩放
          eventCanvas.onmousewheel = eventCanvas.onwheel = function (event) { // 滚轮放大缩小
              // Get mouse offset.
              var mouse = {
                  x: event.offsetX - eventCanvas.offsetLeft,
                  y: event.offsetY - eventCanvas.offsetTop
              };
              // Normalize wheel to +1 or -1.
              var wheel = event.wheelDelta > 0 ? 1 : -1;
              // Compute zoom factor.
              var zoom = Math.exp(wheel * 0.2);
              // 道路占满屏幕时
              if (that.scale * zoom < 1) {
                  zoom = 1 / that.scale;
                  // 1px代表0.01米时
              } else if (that.scale * zoom > 100 / 1) {
                  zoom = 100 / 1 / that.scale;
              }
          
              // for (var i = 0; i < ctxList.length; i++) {
              //     ctxList[i].translate(origin.x, origin.y);
              // }
              ectx.translate(origin.x, origin.y)
              origin.x -= mouse.x / (that.scale * zoom) - mouse.x / that.scale;
              origin.y -= mouse.y / (that.scale * zoom) - mouse.y / that.scale;
              // for (var i = 0; i < canvasMove; i++) {
              //     ctxList[i].scale(zoom, zoom);
              //     ctxList[i].translate(-origin.x, -origin.y);
              // }
              ectx.scale(zoom, zoom);
              ectx.translate(-origin.x, -origin.y);
          
              that.scale *= zoom;
          };
        },


        initCanvasMid: function(canvas){
          var that = this
          console.log('mid')
          this.canvasM = document.getElementById('midCanvas'); //画布对象
          this.contextM = this.canvasM.getContext('2d');//画布显示二维图片
          canvas.selections = false
          this.drawImageMid()
          //鼠标按下事件
          canvas.on("mouse:down", function(e) {
            console.log(e)
            if(e.target != null){
                if('id' in e.target){
                    that.fabricClickId = e.target.id
                    that.fabricClickName = e.target.carName
                }
            }else{
                // if(midCanvas != ''){
                //     that.$refs.setCarInfo.style.display = 'none'
                // }
                
            }
            this.panning = true;
            canvas.selection = false;

            this.dragging = true;
            // console.log(e)
            this.pos = that.windowToCanvas(e.pointer.x, e.pointer.y);  //坐标转换，将窗口坐标转换成canvas的坐标
          });
          //鼠标抬起事件
          canvas.on("mouse:up", function() {
              this.panning = false;
              canvas.selection = false;

              this.dragging = false;
          });
          // 移动画布事件
          canvas.on("mouse:move", function(e) {

              if(this.dragging){
                console.log(e)
                this.posl = that.windowToCanvas(e.pointer.x, e.pointer.y);
                // console.log(this.posl)
                // console.log(this.pos)
                var x = this.posl.x - this.pos.x, y = this.posl.y - this.pos.y;
                // let x = e.e.movementX
                // let y = e.e.movementY
                var delta = new fabric.Point(x,y);
                canvas.relativePan(delta);
                that.imgX = that.imgX + x
                that.imgY = that.imgY + y
                this.pos = JSON.parse(JSON.stringify(this.posl));
                that.drawImageMid()
              }
              
          });
          // var leftTo = canvas._offset.left
          // var topTo = canvas._offset.top
          //鼠标滚动画布放大缩小
          canvas.on("mouse:wheel", function(e) {
            // var box = this.canvasM.getBoundingClientRect();
            var pos = that.windowToCanvas (e.pointer.x, e.pointer.y);
              var zoom = (event.deltaY > 0 ? -0.1 : 0.1) + canvas.getZoom()*1;
              zoom = Math.max(1, zoom); //最小为原来的1/10
              that.$store.commit('setZoom', zoom)
              // var zoomPoint = new fabric.Point(event.pageX-leftTo-box.left, event.pageY-topTo-box.top);
              var zoomPoint = new fabric.Point(pos.x,pos.y);
              canvas.zoomToPoint(zoomPoint, zoom);
              
              event.preventDefault()
              event.stopPropagation()
              // event.wheelDelta = event.wheelDelta ? event.wheelDelta : (event.deltalY * (-40));  //获取当前鼠标的滚动情况
              var newPos = {x:((pos.x-that.imgX)/that.imgScale).toFixed(2) , y:((pos.y-that.imgY)/that.imgScale).toFixed(2)};
              let scale = that.imgScale
              if (event.wheelDelta > 0) {// 放大
                scale = scale + 0.1;
                that.imgX = (1-scale)*newPos.x+(pos.x-newPos.x);
                that.imgY = (1-scale)*newPos.y+(pos.y-newPos.y);
              } else {//  缩小
                scale = scale - 0.1;
                  if(scale<1) {//最小缩放1
                    scale = 1;
                  }
                  that.imgX = (1-scale)*newPos.x+(pos.x-newPos.x);
                  that.imgY = (1-scale)*newPos.y+(pos.y-newPos.y);
                  
              }
              that.imgScale = scale
              that.drawImageMid()
          });
      },
        drawImageMid1: function(){
          this.canvas.add(new fabric.Line([0,0,500, 500],{
              strokeWidth: 2,
              stroke: '#ff0000',
              selectable: false,
              hasBorders: false,
              hasControls: false,
          }))
        },
        drawImage: function() {
          
          this.contextM.clearRect(0, 0, 1920, 1080);
          //绘制道路
          // console.log(this.roadInfo)
          let roadList = this.roadInfo
          
          for(let i=0;i<roadList.length;i++){
            this.contextM.lineWidth = 2;
            this.contextM.beginPath();
            this.contextM.font = "bold 16px '微软雅黑'";
            this.contextM.strokeStyle  = '#000000';
            this.contextM.moveTo((roadList[i][0][0]*1*this.imgScale+this.imgX),(roadList[i][0][1]*1*this.imgScale+this.imgY));
            for(let j=1;j<roadList[i].length;j++){
              this.contextM.lineTo((roadList[i][j][0]*1*this.imgScale+this.imgX),(roadList[i][j][1]*1*this.imgScale+this.imgY));
              if(i == 3){
                if(j==0 || j%30 == 0){
                  this.contextM.fillStyle ="#000000"
                  this.contextM.fillText(roadList[3][j],roadList[2][j][0]*1*this.imgScale+this.imgX,roadList[2][j][1]*1*this.imgScale+this.imgY-15);
                }
                
              }
            }
            // this.contextM.closePath();
            this.contextM.stroke();
          }
          
          if(this.nowTime){
            this.initHistory(this.nowTime,this.toBigCode)
          }
          // console.log(this.dataMap)
        },
        drawImageF: function() {
          this.contextM.clearRect(0, 0, 1920, 1080);
          
          if(this.nowTime){
            this.initHistoryF(this.nowTime)
          }
        },
        // 现场监控首页
        drawImageMid: function() {
          this.contextM.clearRect(0, 0, 1920, 1080);
          this.contextM.fillStyle = 'RGBA(255,255,255, 0.5)';
          // this.contextM.clearRect(0, 0, 1920, 1080);
          this.contextM.fillRect(0, 0, 1000, 850); 
          // 绘制历史数据
          // this.contextM.beginPath()
          // this.contextM.moveTo(50*this.imgScale+this.imgX,50*this.imgScale+this.imgY)
          // this.contextM.lineTo(100*this.imgScale+this.imgX,100*this.imgScale+this.imgY)
          // this.contextM.stroke()
        },
        windowToCanvas(x,y) {
          var box = this.canvasM.getBoundingClientRect();  //这个方法返回一个矩形对象，包含四个属性：left、top、right和bottom。分别表示元素各边与页面上边和左边的距离
          console.log('box:',box)
          // console.log(x,y)
          return {
              x: x - box.left - (box.width - this.canvasM.width) / 2,
              y: y - box.top - (box.height - this.canvasM.height) / 2
          };
        },
        
        setGrid: function(canvas){
            canvas.clear()
            let gridSize = 50;
            let canvasWidth = canvas.width;
            let canvasHeight = canvas.height;
        
            let xLineTotal = Math.floor(canvasHeight / gridSize);
            let yLineTotal = Math.floor(canvasWidth / gridSize);
            // ctx.fillStyle = colorValue;
            // ctx.fillRect(0, 0, canvasWidth, canvasHeight);
            // ctx.stroke();
            var rectBG = new fabric.Rect({
                left: 0,
                top: 0,
                fill: 'RGBA(74, 92, 118, 0.2)',
                width: canvasWidth-2,
                height: canvasHeight,
                selectable: false,
                hasBorders: false,
                hasControls: false,
            }) 
            canvas.add(rectBG)
        
            for (let i = 0; i <= xLineTotal; i++) {
                canvas.add(new fabric.Line([0,i * gridSize - 0.5,canvasWidth, i * gridSize - 0.5],{
                    strokeWidth: 1,
                    stroke: '#DCDCDC',
                    selectable: false,
                    hasBorders: false,
                    hasControls: false,
                }))
            }
        
            for (let i = 0; i <= yLineTotal; i++) {
                canvas.add(new fabric.Line([i * gridSize - 0.5,0,i * gridSize - 0.5, canvasHeight],{
                    strokeWidth: 1,
                    stroke: '#DCDCDC',
                    selectable: false,
                    hasBorders: false,
                    hasControls: false,
                }))
            }
        },
        setRoad(canvas,setArr){
          console.log(setArr)

            let leftArr = setArr[0]
            let rightArr = setArr[2].reverse()
            let areaArr = leftArr.concat(rightArr)
            let areaPath = 'M'+' '+areaArr[0][0]+' '+areaArr[0][1]
            for(let i=1;i<areaArr.length;i++){
                areaPath += ' '+'L'+' '+areaArr[i][0]+' '+areaArr[i][1]
            }
            areaPath = areaPath + 'z'
            canvas.add(new fabric.Path(areaPath,{
                fill: 'RGBA(74, 92, 118, 0.2)',
                selectable: false,
                hasBorders: false,
                hasControls: false,
            }))
        },
        //绘制非标道路
        setUnRoad(canvas, setArr,type) {
            console.log('setroad1',setArr)
            let leftArr = setArr[0];
            let barArr = setArr[2];
            let getArr = setArr[3];
            let getArr1 = setArr[4]; //作业安全区
            let getArr2 = setArr[5]; //障碍安全区
            let areaArr = leftArr;
            let areaPath = "M" + " " + areaArr[0][0] + " " + areaArr[0][1];
            for (let i = 1; i < areaArr.length; i++) {
              areaPath += " " + "L" + " " + areaArr[i][0] + " " + areaArr[i][1];
            }
            areaPath = areaPath + "z";
            
            canvas.add(
              new fabric.Path(areaPath, {
                strokeWidth: 1,
                stroke: "black",
                fill: "RGBA(132,132,198,0)",
                // strokeDashArray: [1,1],
                selectable: false,
                hasBorders: false,
                hasControls: false,
              })
            );
            
            for (let i = 0; i < barArr.length; i++) {
              let barPath = "";
              console.log('setroad')
              for (let j = 0; j < barArr[i].length; j++) {
                if (j == 0) {
                  barPath = "M" + " " + barArr[i][0].x + " " + barArr[i][0].y;
                } else {
                  barPath += " " + "L" + " " + barArr[i][j].x + " " + barArr[i][j].y;
                }
                
                canvas.add(
                  new fabric.Text("S" + j, {
                    fontSize: 12,
                    top: barArr[i][j].y + 5,
                    left: barArr[i][j].x + 5,
                    selectable: false,
                    hasBorders: false,
                    hasControls: false,
                    fill: "black",
                  })
                );
                
                canvas.add(
                  new fabric.Circle({
                    radius: 3,
                    top: barArr[i][j].y - 3, //调整中心点的X轴坐标
                    left: barArr[i][j].x - 3,
                    selectable: false,
                    hasBorders: false,
                    hasControls: false,
                    fill: "#000",
                  })
                );
              }
              barPath = barPath + "z";
              canvas.add(
                new fabric.Path(barPath, {
                  strokeWidth: 1,
                  stroke: "black",
                  fill: "RGBA(132,132,198,0.2)",
                  // strokeDashArray: [1,1],
                  selectable: false,
                  hasBorders: false,
                  hasControls: false,
                })
              );
            }
            
            for (let i = 0; i < setArr[1].length; i++) {
              canvas.add(
                new fabric.Text(
                  setArr[1][i].name +
                    "(" +
                    setArr[1][i].x +
                    "," +
                    setArr[1][i].y +
                    ")",
                  {
                    fontSize: 14,
                    top: setArr[0][i][1] * 1.05 - 20,
                    left: setArr[0][i][0] * 1.05 - 58,
                    selectable: false,
                    hasBorders: false,
                    hasControls: false,
                    fill: "black",
                  }
                )
              );
            }
            
            let workPath = "";
            for (let i = 0; i < getArr.length; i++) {
              if (i == 0) {
                workPath = "M" + " " + getArr[i][0] + " " + getArr[i][1];
              } else {
                workPath += " " + "L" + " " + getArr[i][0] + " " + getArr[i][1];
              }
      
              canvas.add(
                new fabric.Text("W" + [i], {
                  fontSize: 12,
                  top: getArr[i][1] + 5,
                  left: getArr[i][0] + 5,
                  selectable: false,
                  hasBorders: false,
                  hasControls: false,
                  fill: "black",
                })
              );
              
              canvas.add(
                new fabric.Circle({
                  radius: 3,
                  top: getArr[i][1] - 3, //调整中心点的X轴坐标
                  left: getArr[i][0] - 3,
                  selectable: false,
                  hasBorders: false,
                  hasControls: false,
                  fill: "#000",
                })
              );
            }
            workPath = workPath + "z";
            console.log(type)
            let setFillColor = type == 'xc' ? 'RGBA(213,255,255,0)' : 'RGBA(213,255,255,0.5)'
            canvas.add(
              new fabric.Path(workPath, {
                strokeWidth: 1,
                stroke: "blue",
                fill: setFillColor,
                // strokeDashArray: [1,1],
                selectable: false,
                hasBorders: false,
                hasControls: false,
              })
            );
            // this.setGroupFun(canvas)
            if(getArr1.lenght){
              let workPath1 = "";
              for (let i = 0; i < getArr1.length; i++) {
                if (i == 0) {
                  workPath1 = "M" + " " + getArr1[i][0] + " " + getArr1[i][1];
                } else {
                  workPath1 += " " + "L" + " " + getArr1[i][0] + " " + getArr1[i][1];
                }
              }
              workPath1 = workPath1 + "z";
              console.log('setroad1',getArr1,workPath1)
              canvas.add(
                new fabric.Path(workPath1, {
                  strokeWidth: 1,
                  stroke: "#E96B5A",
                  fill: "RGBA(132,132,198,0)",
                  strokeDashArray: [2, 1],
                  selectable: false,
                  hasBorders: false,
                  hasControls: false,
                })
              );
            }
            
            console.log('setroad1',getArr2)
            if (getArr2.length) {
              for (let i = 0; i < getArr2.length; i++) {
                let workPath2 = "";
                for (let j = 0; j < getArr2[i].length; j++) {
                  if (j == 0) {
                    workPath2 = "M" + " " + getArr2[i][0].x + " " + getArr2[i][0].y;
                  } else {
                    workPath2 +=
                      " " + "L" + " " + getArr2[i][j].x + " " + getArr2[i][j].y;
                  }
                }
                workPath2 = workPath2 + "z";
                canvas.add(
                  new fabric.Path(workPath2, {
                    strokeWidth: 1,
                    stroke: "#E96B5A",
                    fill: "RGBA(132,132,198,0)",
                    strokeDashArray: [3, 1],
                    selectable: false,
                    hasBorders: false,
                    hasControls: false,
                  })
                );
              }
            }
          },
        setGroupFun: function(canvas){
            //console.log('111')
            let path1 = [500,500,600,300]
            let patha = new fabric.Line(path1,{
                stroke: 'red'
            })
            let path2 = [600,300,700,500]
            let pathb = new fabric.Line(path2,{
                stroke: 'red'
            })
            let path3 = [700,500,800,300]
            let pathc = new fabric.Line(path3,{
                stroke: 'red'
            })
            let path4 = [800,300,900,500]
            let pathd = new fabric.Line(path4,{
                stroke: 'red'
            })
            let path5 = [900,500,1000,300]
            let pathe = new fabric.Line(path5,{
                stroke: 'red'
            })
            canvas.add(patha)
            canvas.add(pathb)
            canvas.add(pathc)
            canvas.add(pathd)
            canvas.add(pathe)
        }
    }
  };